import React, { useEffect } from 'react'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'

import FormSchemaValidations from './schema-validations'
import FormBase from './form-base'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { setOpenModal, editUserAction, checkIfUserExists } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { editClient } from '../thunks'

const Edit = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector(state => state.customerMaster)
  const { personTypes, taxpayerTypes } = useSelector(state => state.invoiceIssuance)

  // CAT-029: el id depende del ambiente, se resuelve contra el backend
  const idTipoPersona = (codigo) => Number(personTypes?.find?.(item => item.value === codigo)?.id) || null

  // "Tipo de contribuyente" solo se muestra para CCF (03); para el resto el
  // valor sale del default. Solo se acepta lo que exista en CAT-091: un
  // cliente antiguo puede traer guardado un país, y eso debe caer a "Otro".
  // Así, reeditar un cliente con el dato viejo lo deja corregido
  const idContribuyente = (seleccion) => {
    const catalogo = taxpayerTypes || []
    const enCatalogo = catalogo.find(item => item.value === seleccion?.value)
    const otro = catalogo.find(item => item.value === '04')
    return Number(enCatalogo?.id ?? otro?.id) || null
  }


  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      type_of_entity: '',
      nit: '',
      nrc: '',
      society: '',
      type_of_establishment: '',
      address: '',
      phone: '',
      economic_activity: '',
      main_admin_name: '',
      main_admin_email: '',
      reset_main_admin_password: '',
      service_to_acquire_digital_signature: [],
      service_to_acquire_digital_invoice: [],
      isActive: false
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(FormSchemaValidations)
  })

  const inputs = {
    typeEntity: { disabled: true },
    DUI: { disabled: true },
    NIT: { disabled: true },
    NRC: { disabled: true },
    NRC: { disabled: true },
    dteType: { disabled: true }
  }

  const onSubmit = (data) => {

    dispatch(editClient({...data,
      municipalityId: Number(data.municipality?.id) || 528,
      departmentId: Number(data.department?.id) || 15,
      districtId: Number(data.district?.id) || null,
      typeEntityId: idTipoPersona(data.typeEntity.value === "N" ? '1' : '2'),
      largeConsumerId: idContribuyente(data?.largeConsumer),
      dteClientTypeId: Number(data.dteType?.id), // data.dteClientType?.value,
      clientCode: null,
      dteTypeId: Number(data?.dteType?.id),
      company: data.receiverName,
      economicActivityId: Number(data.economicActivity.id),
      codeTypeId: 1,
      country: data?.country?.id || null
    }))
    .unwrap() // Para manejar la respuesta de la acción
    .then(() => {
      // Acción después de que la actualización se complete
      handleClose();
      toast.success("Usuario Editado con éxito")
    })
    .catch(error => {
      console.error('Error updating user:', error);
    });
  }
  const handleClose = () => {
    dispatch(setOpenModal({ type: 'edit', open: false }))
  }

  useEffect(() => {
    if (modal.edit.open && modal.edit.data) {
      
      // Set the form values with the data from the modal
      for (const [key, value] of Object.entries(modal.edit.data)) {
        console.log("key: ", key)
        console.log("value: ", value)
        setValue(key, value)
      }
    }
  }, [modal.edit.open, modal.edit.data, setValue])
  return (
    <Modal
      isOpen={modal.edit.open}
      toggle={ handleClose }
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader className="bg-transparent" toggle={ handleClose }>
        
      </ModalHeader>

      <FormProvider {...{ handleSubmit, control, reset, setValue, formState: { errors } }} >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
              <div style={{display:"flex", justifyContent: "center"}}>
                <h1>Editar cliente</h1>
              </div>
            <FormBase input={inputs} initialTypeEntity={modal.edit.data?.dteType}/>
            <div>
              <p>Campos obligatorios (*)</p>
            </div>
          </ModalBody>

          <ModalFooter className={'d-flex justify-content-center'}>
            <Button color="primary" type="submit">
              Guardar
            </Button>
            <Button
              type="reset"
              color="secondary"
              outline
              onClick={ handleClose }
            >
              Cancelar
            </Button>
            
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

export default Edit
